import { getAPI } from "./axios-base";
export default class RestResourceSms {
  sendSmsToUser(body: any) {
    return getAPI.post(`api/rest/v1/sms/notify-user`, body);
  }

  sendEmailToUser(body: any) {
    return getAPI.post(`api/rest/v1/user/send-email`, body);
  }
}
